import PaperThemeProvider from "./PaperThemeProvider";
import { buildTheme } from "./theme";

export { PaperThemeProvider, buildTheme };
